import { Cookies } from 'react-cookie';
const cookies = new Cookies();

const TOKEN_NAME = 'authToken';
const REFRESH_TOKEN_NAME = 'refreshToken';

export const useAuthToken = () => {
  // const setAuthToken = (authToken: any) => cookies.set(TOKEN_NAME, authToken, { path: '/' });
  const setAuthToken = (authToken: any) => localStorage.setItem(window.REACT_ACCESS_TOKEN_URL, authToken);

  const removeAuthToken = () => localStorage.removeItem(window.REACT_ACCESS_TOKEN_URL);
  // const removeAuthToken = () => cookies.remove(TOKEN_NAME, { path: '/' });

  return [localStorage.getItem(window.REACT_ACCESS_TOKEN_URL), setAuthToken, removeAuthToken];
};
export const useRefreshToken = () => {
  const setRefreshToken = (refreshToken: any) => localStorage.setItem(window.REACT_REFRESH_TOKEN_URL, refreshToken);

  const removeRefreshToken = () => localStorage.removeItem(window.REACT_REFRESH_TOKEN_URL);

  return [localStorage.getItem(REFRESH_TOKEN_NAME), setRefreshToken, removeRefreshToken];
};

export const generateRandomString = (length: any) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

export const generateCodeChallenge = async (codeVerifier: any) => {
  var digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
  const unitArray = new Uint8Array(digest);
  return btoa(String.fromCharCode(...unitArray))
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
};
